import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    cellRender: {
      padding: '1rem',
      display: 'flex',
      alignItems: 'center',
    },
    warning: {
      color: theme.palette.warning.main,
    },
    selected: {
      color: 'white',
    },
    disclaimer: {
      marginLeft: '0.5rem',
    },
    future: {
      display: 'block',
      marginTop: '0.5rem',
    },
    tooltip: {
      marginLeft: '0.5rem',
    },
    tooltipTitle: {
      fontWeight: 700,
    },
    tooltipColor: {
      color: '#585858',
    },
  };
});

export default useStyles;
